var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightning01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.83306 1.66669L1.41094 10.5732C1.12026 10.922 0.974925 11.0964 0.972704 11.2437C0.970773 11.3718 1.02783 11.4936 1.12744 11.5741C1.24201 11.6667 1.46904 11.6667 1.92308 11.6667H7.99972L7.16639 18.3334L14.5885 9.42681C14.8792 9.078 15.0245 8.9036 15.0267 8.7563C15.0287 8.62826 14.9716 8.50643 14.872 8.42594C14.7574 8.33335 14.5304 8.33335 14.0764 8.33335H7.99972L8.83306 1.66669Z",
    stroke: "#B8C5CC",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightning01);
export default __webpack_public_path__ + "static/media/lightning-01.d3906bec98a39a1095a60c80e6adc21e.svg";
export { ForwardRef as ReactComponent };